/* eslint-disable max-len */
import React from 'react';
function MessagingOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 2H3C2.45 2 2 2.45 2 3V17L5.99999 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM15 4V11H5.17L4.58 11.59L4 12.17V4H15ZM19 6H21C21.55 6 22 6.45 22 7V22L18 18H7C6.45 18 6 17.55 6 17V15H19V6Z" })));
}
export default MessagingOutlined;
